import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Paper, BottomNavigation, BottomNavigationAction, Badge,
} from '@mui/material';
import ToolbarStyles from './utils/ToolbarStyles.js';

import {ReactComponent as HomeIcon} from '../resources/images/track2you/Icons_House.svg';
import {ReactComponent as WorkAreaIcon} from '../resources/images/track2you/Icons_Work_Area.svg';
import {ReactComponent as ActivityMapIcon} from '../resources/images/track2you/Icons_Activity_Map.svg';
import { useTranslation } from '../common/components/LocalizationProvider.jsx';

const BottomMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const t = useTranslation();

  const classes = ToolbarStyles();

  const socket = useSelector((state) => state.session.socket);


  const currentSelection = () => {
    if (location.pathname.startsWith('/work')) {
      return 'work';
    } if (location.pathname.startsWith('/activities')) {
      return 'activities';
    } if (location.pathname === '/') {
      return 'home';
    }
    return null;
  };

  const handleSelection = (event, value) => {
    switch (value) {
      case 'home':
        navigate('/');
        break;
      case 'work':
        navigate('/work/workPage');
        break;
      case 'activities':
        navigate('/activities/activitiesPage');
        break;
      default:
        break;
    }
  };

  return (
    <Paper square elevation={6}>
      <BottomNavigation className={classes.bottomNavigation}  value={currentSelection()} onChange={handleSelection} showLabels>
        {/* <BottomNavigationAction label={t('workTitle')} icon={<BusinessCenterIcon />} value="work" /> */}
        <BottomNavigationAction label={'TRABALHO'} icon={<WorkAreaIcon />} value="work" />
        <BottomNavigationAction
          // label={t('homeTitle')}
          label={'HOME'}
          icon={(
              <HomeIcon />
          )}
          value="home"
        />
        {/* <BottomNavigationAction label={t('activitiesTitle')} icon={<QueryStatsIcon />} value="activities" /> */}
        <BottomNavigationAction label={'ATIVIDADES'} icon={<ActivityMapIcon />} value="activities" />
      </BottomNavigation>
      
    </Paper>
  );
};

export default BottomMenu;
